import { CurrencyPipe } from '@angular/common';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BusinessStore } from 'src/model/business/business-store';
import { EInvoiceDoc } from 'src/model/e-invoice..model';
import { FiscalYearInfo, toFiscalYearInfoAbsMonths } from 'src/model/fiscalYearInfo.model';
import { EInvoiceService } from 'src/services/e-invoice.service';
import { FiscalYearInfoService } from 'src/services/fiscal-year-info.service';
import { AddUpdateFiscalYearInfoComponent } from '../add-update-fiscal-year-info/add-update-fiscal-year-info.component';
import { EInvoiceDocListComponent } from '../e-invoice-doc-list/e-invoice-doc-list.component';
import { MatTableController } from '../mat-table-controller';
import { toAbsoluteMonth } from '../month.util';
import { SharedService } from '../Shared/shared-service.service';

@Component({
  selector: 'app-e-invoice-dashboard',
  imports: [FormsModule, NgbModule, MatTableModule, MatSortModule, CurrencyPipe, EInvoiceDocListComponent],
  templateUrl: './e-invoice-dashboard.component.html',
  styleUrl: './e-invoice-dashboard.component.scss',
  providers: [MatTableController, provideNativeDateAdapter()]
})
export class EInvoiceDashboardComponent {
  private eInvoiceService = inject(EInvoiceService);
  private fyInfoService = inject(FiscalYearInfoService);
  private sharedService = inject(SharedService);
  private businessStore = inject(BusinessStore);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  public table = inject(MatTableController<EInvoiceDoc>);

  // readonly currentYear = 2027; // TODO: delete this
  // readonly today = new Date(2027, 5, 0); // TODO: delete this
  readonly currentYear = new Date().getFullYear();
  readonly today = new Date();
  readonly absCurrentMonth = computed(() => toAbsoluteMonth(this.today));

  branchMap = this.businessStore.branchMap;
  // businessNameMap = this.businessStore.businessNameMap;
  branchBusinessMap = this.businessStore.branchBusinessMap;

  // businessYearEnd = computed<Map<number, number>>(() => {
  //   const biz = this.businessList();
  //   return biz ? new Map(biz.map((b) => [b.Id, b.YearEndMonth])) : undefined;
  // });
  fyInfoList = signal<FiscalYearInfo[]>([]);
  currentFyInfo = computed(() => {
    let fyList = this.fyInfoList().map(f => toFiscalYearInfoAbsMonths(f, this.branchBusinessMap()?.get(f.BranchId).YearEndMonth));
    return fyList.filter(f => this.absCurrentMonth() <= f.AbsEndMonth).sort((a, b) => a.AbsStartMonth - b.AbsStartMonth);
  });

  displayedColumns = computed(() => [...this.table.columnDefs()]);
  eInvoiceDocs = signal<EInvoiceDoc[]>([]);

  constructor() {
    this.table.config.set([
      // { columnDef: 'Id', header: 'ID', property: 'Id' },
      { columnDef: 'Business', header: 'Business', property: 'BusinessName' },
      { columnDef: 'TotalAmount', header: 'Total Amount', property: 'TotalInterest', type: 'currency', cssClass: {header: 'align-end', cell: 'text-end' } },
      { columnDef: 'IssuanceDate', header: 'Issuance Date', property: 'IssuanceDate', type: 'date', format: 'dd MMM yyyy' },
      { columnDef: 'CreatedOn', header: 'Created On', property: 'CreatedOn', type: 'date', format: 'dd MMM yyyy, hh:mm:ss a' },
      { columnDef: 'Status', header: 'Status', calculated: (d) => d.SubmittedOn === undefined ? 'Draft' : 'Submitted' },
    ]);

    effect(() => {
      this.getFiscalYearInfos();
    })
  }

  ngOnInit(): void {
    this.getFiscalYearInfos();
    this.getEInvoiceDocs();
  }

  async getFiscalYearInfos() {
    const y = this.currentYear;
    const a = await this.fyInfoService.getFiscalYearInfos({fiscalYear: [y-1, y, y+1]});
    this.fyInfoList.set(a);
  }

  async getEInvoiceDocs() {
    const e = await this.eInvoiceService.getAllEInvoiceDocs();
    this.eInvoiceDocs.set(e);
    this.table.rawData.set([{items: this.eInvoiceDocs()}]);
  }

  addFiscalYearInfo() {
    const modalRef = this.sharedService.openModal(AddUpdateFiscalYearInfoComponent, 'regularModal');
    const instance = modalRef.componentInstance as AddUpdateFiscalYearInfoComponent;
    instance.passEntry.subscribe((f: FiscalYearInfo) => {
      this.fyInfoList.update(list => [...list, f]);
    });
  }

  editFiscalYearInfo(fyInfo: FiscalYearInfo) {
    const modalRef = this.sharedService.openModal(AddUpdateFiscalYearInfoComponent, 'regularModal');
    const instance = modalRef.componentInstance as AddUpdateFiscalYearInfoComponent;
    instance.isEdit = true;
    instance.lockBusiness = true;
    instance.fyInfoToUpdate = fyInfo;
    console.log(fyInfo);
    instance.passEntry.subscribe((f: FiscalYearInfo) => {
      this.fyInfoList.update(list => {
        const i = list.findIndex(l => l.BranchId === f.BranchId && l.FiscalYear === f.FiscalYear);
        list.splice(i, 1, f);
        return [...list];
      });
    })
  }

  addEInvoiceDoc(branchId?: number) {
    this.router.navigate(['/form-j-selection'], branchId ? {
      relativeTo: this.route,
      queryParams: {
        businessId: this.branchBusinessMap()?.get(branchId).Id,
        branchId: branchId,
      },
      queryParamsHandling: 'merge'
    } : {});
  }

  goToFiscalYearList() {
    this.router.navigate(['/fiscal-year-list']);
  }
}
